import PinTypeEnum from "@/enums/PinTypeEnum";
import SelectModeEnum from "@/enums/SelectModeEnum";
import TreeNode from "@/types/TreeNode";
import { SelectModeStrategy } from "./ISelectModeStrategy";
import Pin from "@/types/FilterTree/Pin";
import FilterTreeStore from "../FilterTreeStore";
import IConfigTree from "@/interfaces/IConfigTree";
import FilterT from "@/types/FilterTree/FilterT";
import { StoreMediator } from '@/mediators/StoreMediator';
import { FilterTreeUtils } from '@/components/commons/Utils';

export class SingleMode extends SelectModeStrategy {
    /** 
     * Constructeur avec paramètre
     * @param context Instance de FilterTree
     */
    public constructor(context: FilterTreeStore) {
        super(context);
        this.selectMode = SelectModeEnum.Single;
        this.store.context.commit('setButtonState', { hasHistoricMode: true, hasPropertiesFilter: false, hasToggleCheckOnly: false, hasSelectAll: false, hasClearSelection: false });
    }

    public override Init(nodes : TreeNode[], pins : Pin[], isHistoricMode: boolean, isCheckOnly : boolean, configTree: IConfigTree, cleaned: boolean, grouping : FilterT) {
        if (configTree)
            nodes = (configTree as IConfigTree).Filter(nodes, false);

        for (let node of nodes) {
            node = super.cleanNode(node);
            node.WithCheckBox = false;
        }

        let maxPinId = 0;
        //Il faut prendre le dernier pin sélectionné de type tree
        if (pins && pins.length > 0)
            pins = pins.filter((word) => word.Type == PinTypeEnum.Tree);

        let node: TreeNode = {} as TreeNode;

        if (pins && pins.length > 0) {
            let pin: Pin = pins[pins.length - 1];
            pin.Id = 1;
            node = nodes.find((u) => u.Id == pin.Selections[0]);
            if (node && !node.IsAncestor){
                node.Selected = true;
                pin.TreeNode = node;
                pins = [pin];
                maxPinId++;
            }else{
                node = {} as TreeNode;
                pin.TreeNode = node;
                pins = [];
            }
        }

        this.store.context.commit('setBases', { nodes: nodes, pins: pins, maxPinId: maxPinId});

        if(grouping)
            this.store.context.commit('setGrouping', grouping);

        this.store.context.commit('loadFilter', {} as FilterT);

        if (!this.store.context.getters['GetIsStoreMediatorDisabled'])
            StoreMediator.GetInstance().SelectNodeInComponents(node);

        if (node && Object.keys(node).length > 0)
            this.store.context.commit('openNode', { node: node, scrollIntoView: true });
    }

    public override SetPins(nodes : TreeNode[], pins : Pin[], isHistoricMode: boolean, isCheckOnly : boolean, cleaned: boolean = false){
        throw new Error('Method not implemented in single mode.');
    }

    public override StopPropagation(isContextMenu: boolean, node: TreeNode): boolean {
        return false;
    }

    public override SelectNodes(newNodes: TreeNode[], included: boolean, nodes : TreeNode[], pins : Pin[], maxPinId: number, isHistoricMode: boolean, isCheckOnly : boolean){
        if (pins.length > 0) {
            let treeNode : TreeNode = pins[0].TreeNode;
            treeNode.Selections = [];
            treeNode.Selected = false;
            pins.splice(0, 1);
        }

        if (!newNodes[0].IsAncestor){
            /** Construction de la pin */
            //Si la pin n'existe pas il faut l'ajouter
            let pin: Pin = FilterTreeUtils.SetPinTree(newNodes[0], false, 1);
            pins.push(pin);

            newNodes[0].Selected = true;

            this.store.context.commit('setBases', { nodes: nodes, pins: pins, maxPinId: 1 });

            if (!this.store.context.getters['GetIsStoreMediatorDisabled'])
                StoreMediator.GetInstance().SelectNodeInComponents(newNodes[0]);
        }
    }
    
    /** Passe en mode historique */
    public override SetHistoricMode(nodes : TreeNode[], pins : Pin[], isHistoricMode: boolean, isCheckOnly : boolean){
        // Sur sortie du mode historique : si le noeud sélectionné est déprécié alors on sélectionne le premier noeud parent non déprécié
        if (isHistoricMode == false && pins.length > 0 && pins[0].Depreciated) {
            // Recherche du premier noeud parent non déprécié
            let parentNode: TreeNode = this.store.context.getters['ParentNode']({ childNodeId: pins[0].Id, firstNotDepreciated: true });

            if (parentNode && Object.keys(parentNode).length > 0)
                this.store.context.dispatch('SetSelectedNode', { node: parentNode, openNode: true, scrollIntoView: true });
        }

        for (let treeNode of nodes) {
            this.UpdateNode(isHistoricMode, isCheckOnly, treeNode);
        }

        this.store.context.commit('setBases', { nodes: nodes, pins: pins });
    }

    public override SelectAllNodes(nodes: TreeNode[], isHistoricMode: boolean, isCheckOnly: boolean) {
        throw new Error('Method not implemented in single mode.');
    }

    public override UpdateNode(isHistoricMode: boolean, isCheckOnly: boolean, node: TreeNode) {
        let historic: boolean = !(!node.Depreciated || (node.Depreciated && isHistoricMode));
        node.Hidden = isCheckOnly || historic;
    }
}